import Modal from '../shared/Modal';

export default function NewConferenceYearModal({ open, onClose, showToast }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="New Conference Year"
      footer={
        <>
          <button className="btn" onClick={onClose}>Cancel</button>
          <button className="btn btn-dark" onClick={() => { onClose(); showToast('New conference year created'); }}>Create 2027</button>
        </>
      }
    >
      <div className="notice-bar">
        This will create a new conference year for 2027. The 2026 conference will be archived as read-only.
      </div>
      <div className="form-group">
        <label className="form-label">Conference Year</label>
        <input className="form-input" defaultValue="2027" />
      </div>
      <div className="form-group">
        <label className="form-label">Conference Dates</label>
        <input className="form-input" placeholder="e.g. June 11–14, 2027" />
      </div>
      <div className="form-group">
        <label className="form-label">Copy Teams From</label>
        <select className="form-input">
          <option>2026 — The Belonging Co Conference (current)</option>
          <option>Start fresh — no teams</option>
        </select>
      </div>
    </Modal>
  );
}
